import { render, staticRenderFns } from "./ThePathForward.vue?vue&type=template&id=5b63caaf&"
import script from "./ThePathForward.vue?vue&type=script&lang=js&"
export * from "./ThePathForward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports